import React from 'react';
import {useDispatch, useSelector} from 'react-redux'
import Parameters from './components/Parameters';
import Pricing from './components/Pricing';

import {
  changeParameter,
  doQuote,
  validator,
} from './data/slice'

export default () => {
  const dispatch = useDispatch();

  window.myValidator = validator;

  const {
    parameters,
    quote,
  } = useSelector((state) => state.smc)

  const onChangeParameter = (name, value) => {
    dispatch(changeParameter({name, value}))
    dispatch(doQuote({name, value}))
  }

  return (
    <div className="container">
      <div className="row">
        <div className="col-lg-4">
          <div className="card parameters">
            <div className="card-body">
              <Parameters
                parameters={parameters}
                onChangeParameter={onChangeParameter}
                validator={validator} />
            </div>
          </div>
        </div>
        <div className="col-lg-8">
          <div className='second-section'>
            <div className='container'>
              <Pricing
                parameters={parameters}
                quote={quote} />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
